import React from 'react';
import { painBlocks, painIntro } from '../data/painBlocks';
export function PainSection() {
  return <section className="border-y-4 border-brand-navy bg-white px-4 py-7" data-id="element-134" data-mp="38y6nsgh6u7ej">
      <div className="mx-auto max-w-2xl" data-id="element-135" data-mp="2uy5kyvhd4pwf">
        <h2 className="text-center font-display text-xl font-extrabold uppercase leading-tight text-brand-navy sm:text-2xl" data-id="element-136" data-mp="2uxdprlrogu6o">
          Ti ritrovi in una di queste situazioni?
        </h2>

        <div className="mt-3 space-y-1 text-center text-[15px] font-medium leading-snug text-brand-graphite" data-id="element-137" data-mp="2l7b09vjrlyd3">
          {painIntro.map(line => <p key={line} data-id="element-138" data-mp="2q0vr93mxxs2s">{line}</p>)}
        </div>

        <div className="mt-5 space-y-4" data-id="element-139" data-mp="2bbhcfg0liig0">
          {painBlocks.map(block => <article key={block.title} className="rounded-lg border-2 border-brand-navy/15 bg-brand-cream p-4" data-id="element-140" data-mp="2gaattjj06tlg">
              <h3 className="font-display text-[15px] font-extrabold uppercase leading-tight text-brand-navy sm:text-base" data-id="element-141" data-mp="22buej472rurp">
                <span aria-hidden="true" data-id="element-142" data-mp="3rmhm8x049m6v">{block.emoji}</span> {block.title}
              </h3>

              {block.intro?.map(line => <p key={line} className="mt-2 text-sm font-medium leading-snug text-brand-graphite" data-id="element-143" data-mp="3nkw1yql965mn">
                  {line}
                </p>)}

              {block.items && <ul className="mt-2 flex flex-wrap gap-1.5" data-id="element-144" data-mp="38w9n0pzjffvy">
                  {block.items.map(item => <li key={item} className="rounded border border-brand-navy/15 bg-white px-2 py-1 text-[12px] font-semibold leading-tight text-brand-graphite" data-id="element-145" data-mp="33xyced1f51co">
                      {item}
                    </li>)}
                </ul>}

              {block.outro && <div className="mt-2.5 space-y-1 text-sm font-medium leading-snug text-brand-graphite" data-id="element-146" data-mp="2q3p1xuq2yf2p">
                  {block.outro.map(line => <p key={line} data-id="element-147" data-mp="p30wnga6po19">{line}</p>)}
                </div>}
            </article>)}
        </div>
      </div>
    </section>;
}